<template>
  <div class="fill">
    <el-input
      :disabled="!question.allow_edit"
      v-model="answer"
      @change="(value) => change(value, 'fill')"
      :placeholder="question.tips || `请输入${question.label}`"
    ></el-input>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "fill",
  mixins: [mixins],
  data() {
    return {
      answer: "",
      first: true,
    };
  },
  watch: {
    question: {
      handler(newVal) {
        console.log(newVal);
        if (newVal.default_value && this.first) {
          this.answer = newVal.default_value;
          this.change(newVal.default_value);
        }
        this.first = false;
      },
      immediate: true,
    },
  },
  methods: {
    // change(value) {
    //   this.answerChange(value)
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>